import IStore from "models/IStore";
import React from "react";
import { useSelector } from "react-redux";
import NotificationIcon from "../notification-icon/NotificationIcon";
import ProfileCircle from "./components/profile-circle/ProfileCircle";

const HeaderControl: React.FC = () => {
  const user = useSelector((state: IStore) => state.auth.user);

  return (
    <div className="nav-item header-control">
      {user && (
        <>
          {process.env.REACT_APP_NOTIFICATION_ACTIVE === "1" && <NotificationIcon />}
          <ProfileCircle />
        </>
      )}
    </div>
  );
};

export default HeaderControl;
